import TitlePage from 'components/TitlePage'

export function AppContentWrapper({ children, header, rightHeader }) {
    return (
        <div className='flex flex-col h-full'>
            <TitlePage title={header} options={rightHeader} />
            <div className='content flex-1'>{children}</div>
        </div>
    )
}
